import styled from 'react-emotion'
import { space } from 'styled-system'
import { Image } from 'util/ui'

export default styled(Image)`
  ${space};
`
